import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";

const PercentageIndicator = (props) => {
  const Percentage = props.Percentage;
  var TrailColor;
  var RootColor;

  if (Percentage < 10) {
    TrailColor = "#FFE0E0";
    RootColor = "#DE8C8C";
  } else if (Percentage >= 10 && Percentage < 30) {
    TrailColor = "#FFE3B2";
    RootColor = "#D9B16C";
  } else if (Percentage >= 30 && Percentage < 50) {
    TrailColor = "#B9D3FA";
    RootColor = "#6DA2F2";
  } else if (Percentage >= 50) {
    TrailColor = "#E4F7F2";
    RootColor = "#71D9BB";
  }

  return (
    <React.Fragment>
      <div className="candidate-accuracy">
        <CircularProgressbar
          value={parseInt(Percentage)}
          text={`${parseInt(Percentage)}%`}
          maxValue={100}
          strokeWidth={8}
          styles={{
            // Customize the root svg element
            // Customize the path, i.e. the "completed progress"
            path: {
              // Path color
              stroke: RootColor,
              // Customize transition animation
              transition: "stroke-dashoffset 0.5s ease 0s",
              // Rotate the path
              transform: "rotate(0turn)",
              transformOrigin: "center center",
            },
            // Customize the circle behind the path, i.e. the "total progress"
            trail: {
              // Trail color
              stroke: TrailColor,
              // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
              strokeLinecap: "butt",
              // Rotate the trail
              transform: "rotate(0turn)",
              transformOrigin: "center center",
            },
            // Customize the text
            text: {
              // Text color
              fill: "#474F59",
              fontSize: "22px",
              fontFamily: "Poppins",
            },
          }}
        />
      </div>
    </React.Fragment>
  );
};

export default PercentageIndicator;
